<template>
    <form @submit.prevent novalidate>
        <p>You can search the claims below to further filter your results:</p>
        <div class="flex-grid flex-grid--reduced-bottom-margin-slight a-form-inputs p-compare-reserve__search-buttons">
            <div class="flex-grid__item--third">
                <input type="text" v-model="searchTerm">
            </div>
            <button class="a-button a-button--small" @click="doSearch">Search</button>
            <button class="a-button a-button--small" @click="doReset">Reset</button>
        </div>
    </form>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'search',
        data() {
            return {
                searchTerm: ''
            }
        },
        methods: {
            ...mapActions('reserves/compare', ['search', 'resetSearch']),
            doSearch() {
                this.search(this.searchTerm);
            },
            doReset() {
                this.resetSearch().then(() => this.searchTerm = '');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Search.vue?e4ee6bce